import { render, staticRenderFns } from "./CompensationUser.vue?vue&type=template&id=77e4935c&scoped=true"
import script from "./CompensationUser.vue?vue&type=script&lang=js"
export * from "./CompensationUser.vue?vue&type=script&lang=js"
import style0 from "./CompensationUser.vue?vue&type=style&index=0&id=77e4935c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e4935c",
  null
  
)

export default component.exports